/** Append group_id to URLSearchParams when present. */
export function appendGroupIdParam(params, groupId) {
  if (groupId && params && typeof params.append === 'function') {
    params.append('group_id', groupId);
  }
  return params;
}

/** Append group_id to a query string (with or without leading ?). */
export function withGroupIdQuery(query, groupId) {
  if (!groupId) return query || '';
  const base = query || '';
  // If base is raw params without ?, treat as params
  if (!base) return `group_id=${encodeURIComponent(groupId)}`;
  if (base.startsWith('?')) {
    return `${base}&group_id=${encodeURIComponent(groupId)}`;
  }
  return `${base}&group_id=${encodeURIComponent(groupId)}`;
}

/**
 * Stable key for analytics soft-load: same group+range (+ dates / page / agent)
 * revisits keep cached UI; group or timeline changes hard-load (skeleton).
 */
export function buildAnalyticsFetchKey(arg = {}) {
  const a = arg && typeof arg === 'object' ? arg : {};
  return [
    a.group_id ?? '',
    a.range ?? '',
    a.startDate || a.from || '',
    a.endDate || a.to || '',
    a.page ?? '',
    a.limit ?? '',
    a.agent_id ?? '',
  ]
    .map((v) => (v == null ? '' : String(v)))
    .join('::');
}

/** Set loading for pending: soft-load on same key revisit, skeleton when key changes or no data. */
export function applyAnalyticsPendingLoading(state, arg) {
  const key = buildAnalyticsFetchKey(arg);
  const hasCachedData = state.data != null;
  const isRevisit =
    hasCachedData && state.lastFetchKey != null && state.lastFetchKey === key;
  state.loading = !isRevisit;
}

/** Record the fetch key after a successful response (call after state.loading = false). */
export function markAnalyticsFetchKey(state, arg) {
  state.lastFetchKey = buildAnalyticsFetchKey(arg);
}
